import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import menuStyles from './menu.module.scss'

MainMenuIcon.prototypes = {
    icon: PropTypes.node,
    iconActive: PropTypes.node,
    activeClassName: PropTypes.string,
    className: PropTypes.string,
}

export default function MainMenuIcon({
    icon,
    iconActive,
    activeClassName,
    className,
}) {
    return iconActive || icon ? (
        <span className={menuStyles.mainIconWrapper}>
            {icon && (
                <FontAwesomeIcon
                    icon={icon}
                    className={cx(menuStyles.icon, className)}
                />
            )}
            {iconActive && (
                <FontAwesomeIcon
                    icon={iconActive}
                    className={cx(menuStyles.iconActive, activeClassName)}
                />
            )}
        </span>
    ) : null
}
